<template>
  <div>
    <div class="pkg-search-box pkg-content">
      <!--调配详情-->
      <div>
        <div style="height: 20px;line-height: 30px;text-align: inherit;font-weight: bold;font-size: 20px;">调配计划详情</div>
        <br>
          <el-form label-width="auto"
                   label-position="left"
                   :model="dataForm">
            <el-row>
              <el-col :span="6">
              <!-- 调配单号 -->
                <el-form-item :label="$t('vehicleAllocation.deploymentNo')"
                prop="courseNameCn">
                {{dataForm.deploymentNo}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 调配单状态 -->
                <el-form-item :label="$t('vehicleAllocation.status')"
                              prop="courseNameCn">
                  {{dataForm.statusNmae}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 申请人 -->
                <el-form-item :label="$t('vehicleAllocation.applicantName')"
                              prop="courseNameCn">
                  {{dataForm.applicantName}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 申请时间 -->
                <el-form-item :label="$t('vehicleAllocation.applyTime')"
                              prop="courseNameCn">
                  {{dataForm.applyTime}}
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
      </div>
      <!--车辆的下一个安排-->
      <div>
      <div style="background-color: #ccc;height: 30px;line-height: 30px;text-align: center;font-weight: bold;" v-if="showNext">该车辆下一个安排</div>
        <div style="border-style:solid;border-width:0.5px;border-color:#999999;" v-if="showNextVehicle">
          <el-form
                  style="font-weight: bold;"
                  label-width="auto"
                  label-position="left"
                  :model="dataFormNext"
          >
            <el-row :gutter="3">
              <el-col :span="4">
                <!-- 安排类型 -->
                <el-form-item :label="$t('vehicleAllocation.arrangeType')">
                  {{dataFormNext.bookTypeName}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 排期编号 -->
                <el-form-item v-if="dataFormNext.bookType === '1'" :label="$t('vehicleAllocation.offeringNo')">
                  {{dataFormNext.offeringNo}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 调配单号 -->
                <el-form-item v-if="dataFormNext.bookType === '2'" :label="$t('vehicleAllocation.deploymentNo')">
                  {{dataFormNext.deploymentNo}}
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 上课开始时间 -->
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item :label="$t('vehicleAllocation.courseDateE')">
                  {{dataFormNext.scheduleDateS}}
                </el-form-item>
              </el-col>
            </el-row>
            <!--上课结束时间-->
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item :label="$t('vehicleAllocation.courseDateS')">
                  {{dataFormNext.scheduleDateE}}
                </el-form-item>
              </el-col>
            </el-row>
            <!--上课场地-->
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item v-if="dataFormNext.bookType === '1'" :label="$t('vehicleAllocation.courseStieInfo')">
                  {{dataFormNext.siteName}}
                </el-form-item>
              </el-col>
            </el-row>
            <!--始发地-->
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item v-if="dataFormNext.bookTypeName === '运输安排'" :label="$t('vehicleAllocation.originalPlace')">
                  {{dataFormNext.originalPlace}}
                </el-form-item>
              </el-col>
            </el-row>
            <!--目的地-->
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item v-if="dataFormNext.bookType === '2'" :label="$t('vehicleAllocation.destinationPlace')">
                  {{dataFormNext.destinationPlace}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="border-style:solid;border-width:0.5px;border-color:#999999;" v-if="showNextVehicleNo">
          <el-form
                  style="font-weight: bold;"
                  label-width="auto"
                  label-position="left"
                  :model="dataFormNext"
          >
            <el-row :gutter="3">
              <el-col :span="4">
                <el-form-item>
                  {{'无'}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!--调配原因-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <div><span style="color:red;font-size:9px;">*&nbsp;</span>调配原因</div>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col :span="5">
                <!--this.states === '30'-->
                <el-select :disabled='true' v-model="dataForm.deploymentReason">
                  <el-option v-for="(item,index) in allocationReasonsArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--目的地-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div><span style="color:red;font-size:9px;">*&nbsp;</span>目的地</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row :gutter="5">
              <!--dataForm.deploymentReason === '10'? true : false" @change=selectdestinationPlaceType-->
              <el-col :span="5">
                <el-select :disabled="true" v-model="dataForm.destinationPlaceType">
                  <el-option v-for="(item,index) in destinationPlace"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" v-if="dataForm.destinationPlaceType === '10'">
                <el-input v-model="dataForm.destinationPlace"
                          @focus="showSuboSiteDlg()"
                          :disabled="true"
                          readonly
                          :placeholder="$t('res.vehinfo.select')"></el-input>
                <el-input v-model="dataForm.destinationPlaceId"
                          v-show="false"></el-input>
              </el-col>
              <el-col :span="5" v-if="dataForm.destinationPlaceType === '20'">
                <el-input style="display: inline-block;"
                          :disabled="true"
                          v-model="dataForm.destinationPlace">
                </el-input>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--选择课程-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;" v-if="dataForm.deploymentReason !== '20' && dataForm.deploymentReason !== '30'">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <!--<div class="link-type"-->
                   <!--:disabled="this.states === '30' || this.type == 'query'"-->
                   <!--@click="selectCourseClick(courseList)"><span style="color:red;font-size:9px;">*&nbsp;</span>选择课程</div>-->
              <!--this.states === '30' || this.type == 'query'-->
              <el-link type="primary" @click="selectCourseClick(courseList)" :disabled="true"><span style="color:red;font-size:9px;">*&nbsp;</span>选择排期</el-link>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col>
                <el-table :data="courseList"
                          border
                          style="width: 100%;">
                  <el-table-column prop="courseNo"
                                   header-align="center"
                                   type="index"
                                   align="center"
                                   :label="$t('res.rela.label')">
                  </el-table-column>
                  <!-- 排期编号 -->
                  <el-table-column prop="offeringNo"
                                   header-align="center"
                                   align="center"
                                   width="100"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringNo')">
                  </el-table-column>
                  <!-- 课程编号 -->
                  <el-table-column prop="courseCode"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.courseCode')">
                  </el-table-column>
                  <!-- 课程名称 -->
                  <el-table-column prop="courseNameCn"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.courseNameCn')">
                  </el-table-column>
                  <!-- 课程分类 -->
                  <!--<el-table-column prop="courseCatalogName"-->
                                   <!--header-align="center"-->
                                   <!--align="center"-->
                                   <!--show-overflow-tooltip-->
                                   <!--:label="$t('vehicleAllocation.courseCatalogName')">-->
                  <!--</el-table-column>-->
                  <!-- 开始时间 -->
                  <el-table-column prop="offeringDateS"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringDateS')">
                  </el-table-column>
                  <!-- 结束时间 -->
                  <el-table-column prop="offeringDateE"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringDateE')">
                  </el-table-column>
                  <!-- 操作 -->
                  <el-table-column fixed="right"
                                   align="center"
                                   width="100"
                                   v-if="this.type !== 'query'"
                                   :label="$t('handle')">
                    <template slot-scope="scope">
                      <el-dropdown trigger="click"
                                   placement="bottom">
                                  <span class="el-dropdown-link">
                                    <!-- {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em> -->
                                    <el-dropdown-item class="el-dropdown-link"
                                                      @click.native="deleteOffering(scope.$index)">{{ $t('delete') }}</el-dropdown-item>
                                    <!-- <el-dropdown-item @click.native="gotoView('delete', scope.row.courseVehicleRelaId)">{{ $t('delete') }}</el-dropdown-item> -->
                                  </span>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--运输开始时间-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div><span style="color:red;font-size:9px;">*&nbsp;</span>运输开始时间</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col :span="5">
                <el-date-picker v-model="dataForm.transportDateS"
                                type="date"
                                :disabled="this.states === '30' || this.type === 'query'"
                                @change="(value)=>dataUpdate('start')"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('res.cri.startTime')">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--运输结束时间-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div><span style="color:red;font-size:9px;">*&nbsp;</span>运输结束时间</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col :span="5">
                <el-date-picker v-model="dataForm.transportDateE"
                                type="date"
                                :disabled="this.type === 'query'"
                                @change="(value)=>dataUpdate('end')"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('res.cri.inputEndTime')">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--选择车辆-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <!--<div class="link-type"-->
                   <!--disabled="this.type === 'query'"-->
                   <!--@click="selectVehicleClick"><span style="color:red;font-size:9px;">*&nbsp;</span>选择车辆</div>-->
              <el-link type="primary" @click="selectVehicleClick" :disabled="this.states === '30' || this.type == 'query' || dataForm.deploymentReason === '30'"><span style="color:red;font-size:9px;">*&nbsp;</span>选择车辆</el-link>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col>
                <el-table :data="vehicleInfoList"
                          border
                          style="width: 100%;">
                  <el-table-column prop="courseNo"
                                   header-align="center"
                                   type="index"
                                   align="center"
                                   :label="$t('res.rela.label')">
                  </el-table-column>
                  <!-- 车辆ID -->
                  <el-table-column prop="id"
                                   header-align="center"
                                   align="center"
                                   v-if="false"
                                   width="100"
                                   :label="$t('handle')">
                  </el-table-column>
                  <!-- 车辆底盘号 -->
                  <el-table-column prop="chassisNo"
                                   header-align="center"
                                   align="center"
                                   width="100"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.chassisNo')">
                  </el-table-column>
                  <!-- 车型分类 -->
                  <el-table-column prop="classCnName"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.vehicleClassId')">
                  </el-table-column>
                  <!-- 所属公司 -->
                  <el-table-column prop="companyCnName"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.companyId')">
                  </el-table-column>
                  <!-- 所属场地 -->
                  <el-table-column prop="siteCnName"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.subordinateSiteId')">
                  </el-table-column>
                  <!-- 当前场地 -->
                  <el-table-column prop="presentSiteName"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.presentSiteId')">
                  </el-table-column>
                  <!-- 车辆分类 -->
                  <el-table-column prop="vehicleClassification"
                                   :formatter="vehicleClassFormatter"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.vehicleClassification')">
                  </el-table-column>
                  <!-- 车辆标签 -->
                  <el-table-column prop="classroomLabel"
                                   header-align="center"
                                   align="center"
                                   :label="$t('res.vehinfo.label')">
                    <template slot-scope="scope">
                      <!--查看-->
                      <span class="el-dropdown-link"
                            v-if="scope.row.number !== null"
                            @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                    </template>
                  </el-table-column>
                  <!-- 优先级 -->
                  <!--<el-table-column prop="priority"-->
                                   <!--header-align="center"-->
                                   <!--align="center"-->
                                   <!--:width="150"-->
                                   <!--:label="$t('res.rela.priority')">-->
                    <!--<template slot-scope="scope">-->
                      <!--<div style="line-height: 34px;">-->
                        <!--<el-select style="width: 80px!important;display: inline-block;"-->
                                   <!--v-model="scope.row.priority"-->
                                   <!--clearable>-->
                          <!--<el-option v-for="(item,index) in priorityArr"-->
                                     <!--:key="index"-->
                                     <!--:label="item.name"-->
                                     <!--:value="item.code">-->
                          <!--</el-option>-->
                        <!--</el-select>-->
                      <!--</div>-->
                    <!--</template>-->
                  <!--</el-table-column>-->
                  <!-- 状态 -->
                  <!--<el-table-column prop="status"-->
                                   <!--header-align="center"-->
                                   <!--align="center"-->
                                   <!--width="100"-->
                                   <!--show-overflow-tooltip-->
                                   <!--:label="$t('res.vehinfo.status')">-->
                  <!--</el-table-column>-->
                  <!-- 操作 -->
                  <!--<el-table-column fixed="right"-->
                                   <!--align="center"-->
                                   <!--width="100"-->
                                   <!--:label="$t('handle')">-->
                    <!--<template slot-scope="scope">-->
                      <!--<el-dropdown trigger="click"-->
                                   <!--placement="bottom">-->
                                  <!--<span class="el-dropdown-link">-->
                                    <!--&lt;!&ndash; {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon&#45;&#45;right"></em> &ndash;&gt;-->
                                    <!--<el-dropdown-item class="el-dropdown-link"-->
                                                      <!--@click.native="deleteVehicle(index, scope.$index)">{{ $t('delete') }}</el-dropdown-item>-->
                                    <!--&lt;!&ndash; <el-dropdown-item @click.native="gotoView('delete', scope.row.courseVehicleRelaId)">{{ $t('delete') }}</el-dropdown-item> &ndash;&gt;-->
                                  <!--</span>-->
                      <!--</el-dropdown>-->
                    <!--</template>-->
                  <!--</el-table-column>-->
                </el-table>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--始发地-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div><span style="color:red;font-size:9px;">*&nbsp;</span>始发地</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col :span="5">
                <el-input style="display: inline-block;"
                          :disabled="true"
                          v-model="dataForm.originalPlace">
                </el-input>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--备注-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div>备注</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col>
                <el-input style="display: inline-block;"
                          :disabled="this.states === '30'|| this.type === 'query'"
                          type="textarea"
                          placeholder="请输入内容"
                          maxlength ="500"
                          v-model="dataForm.remark">
                </el-input>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <!--关联调配单-->
      <el-container style="border-style:solid;border-width:0.5px;border-color:#999999;" v-if="dataForm.deploymentReason === '30'">
        <el-aside width="10%" style="background-color: #D3DCE6; color: #333; display: flex; justify-content: center; align-items: center; line-height: 100%;">
          <el-row>
            <el-col style="text-align: center;">
              <div>关联调配单</div>
            </el-col>
          </el-row>
        </el-aside>

        <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col :span="5"
                      style=" text-align:left;">
                <div class="link-type"
                     style="color: blue">{{dataForm.linkDeploymentNo}}</div>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
      <br>
      <!--关联课程详情-->
      <div v-if="!(this.states === '40' && dataForm.deploymentReason === '30')">
        <div style="background-color: #ccc;height: 30px;line-height: 30px;text-align: inherit;font-weight: bold;">关联课程详情</div>
         <div style="border-style:solid;border-width:0.5px;border-color:#999999;">
          <el-container>
          <el-main style="color: #333; text-align: center; line-height: 100%;">
            <el-row>
              <el-col>
                <el-table :data="courseDetailedList"
                          border
                          style="width: 100%;">
                  <el-table-column prop="courseNo"
                                   header-align="center"
                                   type="index"
                                   align="center"
                                   :label="$t('res.rela.label')">
                  </el-table-column>
                  <!-- 排期编号 -->
                  <el-table-column prop="offeringNo"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringNo')">
                  </el-table-column>
                  <!--课程编号-->
                  <el-table-column prop="courseCode"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.courseCode')">
                  </el-table-column>
                  <!-- 课程名称 -->
                  <el-table-column prop="courseNameCn"
                                   header-align="center"
                                   align="center"
                                   width="100"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.courseNameCn')">
                  </el-table-column>
                  <!-- 课程分类名称 -->
                  <!--<el-table-column prop="courseCatalogName"-->
                                   <!--header-align="center"-->
                                   <!--align="center"-->
                                   <!--show-overflow-tooltip-->
                                   <!--:label="$t('vehicleAllocation.courseCatalogName')">-->
                  <!--</el-table-column>-->
                  <!-- 开始时间 -->
                  <el-table-column prop="offeringDateS"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringDateS')">
                  </el-table-column>
                  <!-- 结束时间 -->
                  <el-table-column prop="offeringDateE"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicleAllocation.offeringDateE')">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
         </div>
      </div>
    </div>
    <!-- 按钮区域 -->
    <div class="pkg-search-box pkg-content"
         style="margin-top: 30px;">
      <div class="btn-position-up"
           style="text-align:right;">
        <!-- 保存按钮 -->
        <el-button type="primary"
                   v-if="this.type === 'update'"
                   :loading="dataListLoading"
                   @click="dataFormSubmitHandle()">{{ $t('trainer.save') }}</el-button>
        <!-- 编辑按钮 -->
        <el-button type="primary"
                   v-if="this.type === 'query'&& this.$route.query.states !=='40'"
                   @click="Update('update')">{{ $t('vehicleAllocation.update') }}</el-button>
        <!-- 返回按钮 -->
        <el-button type="info"
                   :loading="dataListLoading"
                   @click="backPage()">{{ $t('trainer.close') }}</el-button>
      </div>
    </div>

    <!-- 车辆选择页面 -->
    <el-dialog :title="$t('vehicleAllocation.selectionVehicle')"
               :visible="isShowsite"
               width="80%"
               :before-close="handleClose">
      <menu-element ref="vehicleInfoRef"
                    :isSelectElection='true'
                    v-on:onOk="onOk"
                    :startTime="startTime"
                    :endTime="endTime"
                    :siteId="dataForm.destinationPlaceId"></menu-element>
    </el-dialog>

    <!-- 课程查询 -->
    <el-dialog :title="$t('res.courseclassroomrela.alternativeCourse')"
               :modal="false" width="90%"
               :visible.sync="courseSelect">
      <course-select @couronOk="couronOk"
                     @cancel="cancel"
                     ref="selCertCourseDialog"
                     :courseInfoList="courseList"
                     :destinationPlace="dataForm.destinationPlace"
                     :destinationPlaceId="dataForm.destinationPlaceId"></course-select>
    </el-dialog>

    <!-- 所属场地-->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='true'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="selectTable"
                      v-bind:statusList="queryStatusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>

    <!-- 标签查看 -->
    <el-dialog title="标签查看"
               :visible="isShowLable"
               width="70%"
               :before-close="showLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  // import mixinViewModule from '@/mixins/view-module'
  import subordinateSite from '@/components/rm/subordinate-site-allocation/index'
  import courseSelect from '@/components/rm/allocation-course-select/index'
  import AddOrUpdate from './trainerinformation-add-or-update'
  import ClassTree from '@/components/rm/class-tree/index'
  import MenuItem from '@/components/rm/allocation-vehicle-select/index'
  import Tag from '@/components/rm/label-select/index'
  import VueI18n from '@/i18n'
  import Vue from 'vue'
  export default {
    // mixins: [mixinViewModule],
    components: {
      AddOrUpdate,
      Tag,
      'subordinate-site': subordinateSite,
      'class-tree': ClassTree,
      'menu-element': MenuItem,
      'course-select' : courseSelect
    },
    data () {
      return {
        dataListLoading: false,
        updateId: '',
        showNext: true,
        showNextVehicle: true,
        showNextVehicleNo: false,
        // 时间 起
        startTime: '',
        // 时间 止
        endTime: '',
        // 最早排期时间
        strDate:'',
        // 最晚排期时间
        enDate:'',
        // 页面初始化车辆ID
        vehicleId:'',
        isShowLable: false,
        // 判断为编辑还是查看
        type: '',
        states:'',
        isShowsite: false,
        courseShowFlg: false,
        courseSelect: false,
        // 选择的课程
        courseList: [],
        // 排期明细
        courseDetailedList: [],
        vehicleInfoList: [],
        stationIndex: '',
        coursevehindex: '',
        allocationReasonsArr: this.enums['allocationReasons'],
        // 调配原因
        allocationReasonsList: [],
        // 目的地
        destinationPlace: this.enums['destinationPlace'],
        queryStatusList:['10'],
        selectTable: [],
        // 是否显示所属场地
        isShowSuboSite: false,
        checkList: [],
        // 模块id，20 代表组织管理模块
        moduleId: '20',
        bussinessTypeId: 7,
        bussinessTypeChecked: 7,
        //dataListLoading: false,
        vehicleDeploymentOVo:[],
        vehicleDeploymentOApendVo:[],
        dataForm: {
          id:'',
          deploymentReason: '',
          transportDateS: '',
          transportDateE: '',
          originalPlaceId: '',
          originalPlace: '',
          remark: '',
          destinationPlace:'',
          destinationPlaceType: '',
          destinationPlaceId:'',
          subordinateSite:'',
          vehicleNo:'',
          vehicleId:'',
          deploymentNo:'',
          status:'',
          statusNmae:'',
          applyTime:'',
          applicantName:'',
          lastDate:'',
          linkDeploymentNo:''
        },
        // 页面数据
        updateDataForm: {
          id:'',
          deploymentReason: '',
          transportDateS: '',
          transportDateE: '',
          originalPlaceId: '',
          originalPlace: '',
          remark: '',
          destinationPlace:'',
          destinationPlaceType: '',
          destinationPlaceId:'',
          subordinateSite:'',
          vehicleNo:'',
          vehicleId:'',
          deploymentNo:'',
          status:'',
          statusNmae:'',
          applyTime:'',
          applicantName:'',
          lastDate:''
        },
        // 车辆下一个安排
        dataFormNext: {
          vehicleId:'',
          bookType:'',
          bookTypeName:'',
          scheduleDateS:'',
          scheduleDateE:'',
          courseCode:'',
          siteName:'',
          offeringNo:'',
          deploymentNo:'',
          destinationPlace:'',
          originalPlace:''
        },
        targetForm: {
          groupType: '',
          trainerRole: '',
          taLevel: '',
          isBest: '20',
          annual: '',
          target: ''
        }

      }
    },
    computed: {
      // 获取请求头
      headers: function headers () {
        let headersObj = {
          token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
        }
        return headersObj
      }
    },
    mounted () {
      this.queryDataList()
      this.$eventHub.$on(this.GLOBAL.COURSE_VEHICALERELA, (data) => {
        this.queryDataList()
      })
    },
    methods: {
      queryDataList () {
        this.$nextTick(() => {
          // this.$refs['dataForm'].resetFields()
          this.dataForm.id = this.$route.query.id
          this.type = this.$route.query.type
          this.states = this.$route.query.states
          this.getInfo()
        })
      },
      // 加载页面时赋值
      getInfo () {
        let _this = this
        let url = ''
        let param = ''
        url = '/rm/vehicleinfoDeployment/find'
        param = {
          ..._this.dataForm,
        }
        _this.$request.post(
                url, param
        ).then((data) => {
          console.info('data查看出来的值------------------->', data)
          this.dataForm = data
          this.updateId = data.id
          this.vehicleId = data.vehicleId
          this.updateDataForm.id = data.id
          this.updateDataForm.deploymentReason = data.deploymentReason
          this.updateDataForm.transportDateS = data.transportDateS
          this.updateDataForm.transportDateE = data.transportDateE
          this.updateDataForm.originalPlaceId = data.originalPlaceId
          this.updateDataForm.originalPlace = data.originalPlace
          this.updateDataForm.remark = data.remark
          this.updateDataForm.destinationPlace = data.destinationPlace
          this.updateDataForm.destinationPlaceType = data.destinationPlaceType
          this.updateDataForm.destinationPlaceId = data.destinationPlaceId
          this.updateDataForm.subordinateSite = data.subordinateSite
          this.updateDataForm.vehicleNo = data.vehicleNo
          this.updateDataForm.vehicleId = data.vehicleId
          this.updateDataForm.deploymentNo = data.deploymentNo
          this.updateDataForm.status = data.status
          this.updateDataForm.statusNmae = data.statusNmae
          this.updateDataForm.applyTime = data.applyTime
          this.updateDataForm.applicantName = data.applicantName
          this.updateDataForm.lastDate = data.lastDate
          this.vehicleDeploymentOVo = data.vehicleDeploymentOVoList
          this.vehicleDeploymentOApendVo = data.vehicleDeploymentOApendVo
          if(data.destinationPlaceId){
            this.dataForm.destinationPlaceType = '10'
          }else{
            this.dataForm.destinationPlaceType = '20'
          }
          this.dataForm.statusNmae = this.statusFormatter(this.dataForm.status)
          if(data.vehicleDeploymentOVoList.length === 0 && data.vehicleDeploymentOApendVo.length === 0){
              this.dataForm.lastDate = this.dateFormat("YYYY-mm-dd",new Date(new Date(this.dataForm.transportDateE.replace(/-/g, '/')).getTime() + 24 * 60 * 60 * 1000))
          }else{
            let dateList = []
            let vehicleDeploymentOVoList = []
            let vehicleDeploymentOApendVo = []
            if(data.vehicleDeploymentOVoList.length > 0){
              // 结束时间
              // let enDateList = []
              if(data.vehicleDeploymentOVoList.length > 0){
                for(let i = 0; i < data.vehicleDeploymentOVoList.length; i++){
                  vehicleDeploymentOVoList.push(new Date(data.vehicleDeploymentOVoList[i].offeringDateE.replace(/-/g, '/')).getTime())
                }
              }
              // 结束时间从小到大排序
              // let enDateListS = []
              let vehicleDeploymentOVoListS = []
              for (var i = 0; i < vehicleDeploymentOVoList.length; i++) {
                for (var j = 0; j < vehicleDeploymentOVoList.length -i - 1; j ++) {
                  if (vehicleDeploymentOVoList[j] > vehicleDeploymentOVoList[j+1]) {  // 相邻元素两对比
                    vehicleDeploymentOVoListS = vehicleDeploymentOVoList [j+1];
                    vehicleDeploymentOVoList[j+1]= vehicleDeploymentOVoList [j];
                    vehicleDeploymentOVoList[j] = vehicleDeploymentOVoListS;
                  }
                }
              }
              // console.info('最早的开始时间------------------->', new Date(strDateList[0]))
              console.info('vehicleDeploymentOVoList最晚的结束时间------------------->', new Date(vehicleDeploymentOVoList[vehicleDeploymentOVoList.length - 1]))
              // vehicleDeploymentOVoList集合中最晚的结束时间
              let schedulingDate = new Date(vehicleDeploymentOVoList[vehicleDeploymentOVoList.length - 1])
              console.info('dateList1-------------------->', this.dateFormat("YYYY-mm-dd",schedulingDate))
              dateList.push(schedulingDate)
            }
            if(data.vehicleDeploymentOApendVo.length > 0){
              // 结束时间
              // let enDateList = []
              if(data.vehicleDeploymentOApendVo.length > 0){
                for(let i = 0; i < data.vehicleDeploymentOApendVo.length; i++){
                  vehicleDeploymentOApendVo.push(new Date(data.vehicleDeploymentOApendVo[i].offeringDateE.replace(/-/g, '/')).getTime())
                }
              }
              // 结束时间从小到大排序
              // let enDateListS = []
              // let vehicleDeploymentOVoListS = []
              let vehicleDeploymentOApendVoListS = []
              for (var i = 0; i < vehicleDeploymentOApendVo.length; i++) {
                for (var j = 0; j < vehicleDeploymentOApendVo.length -i - 1; j ++) {
                  if (vehicleDeploymentOApendVo[j] > vehicleDeploymentOApendVo[j+1]) {  // 相邻元素两对比
                    vehicleDeploymentOApendVoListS = vehicleDeploymentOApendVo [j+1];
                    vehicleDeploymentOApendVo[j+1]= vehicleDeploymentOApendVo [j];
                    vehicleDeploymentOApendVo[j] = vehicleDeploymentOApendVoListS;
                  }
                }
              }
              // console.info('最早的开始时间------------------->', new Date(strDateList[0]))
              console.info('vehicleDeploymentOVoList最晚的结束时间------------------->', new Date(vehicleDeploymentOApendVo[vehicleDeploymentOApendVo.length - 1]))
              // vehicleDeploymentOApendVo集合中最晚的结束时间
              let schedulingDetailedDate = new Date(vehicleDeploymentOApendVo[vehicleDeploymentOApendVo.length - 1])
              console.info('dateList2-------------------->', this.dateFormat("YYYY-mm-dd",schedulingDetailedDate))
              dateList.push(schedulingDetailedDate)
            }
            // 判断三个时间的大小
            dateList.push(new Date(this.dataForm.transportDateE.replace(/-/g, '/')))
            // 从小到大排序
            // let enDateListS = []
            let dateListS = []
            for (var i = 0; i < dateList.length; i++) {
              for (var j = 0; j < dateList.length -i - 1; j ++) {
                if (dateList[j] > dateList[j+1]) {  // 相邻元素两对比
                  dateListS = dateList [j+1];
                  dateList[j+1]= dateList [j];
                  dateList[j] = dateListS;
                }
              }
            }
            console.info('最晚的结束时间----------------------->', new Date(dateList[dateList.length - 1]))
            console.info('dateList计算出来的时间集----------------->',dateList)
            let dateL = new Date(dateList[dateList.length - 1])
            this.dataForm.lastDate = this.dateFormat("YYYY-mm-dd",new Date(dateL.getTime() + 24 * 60 * 60 * 1000))
          }
          // this.dataForm.lastDate = this.dataForm.transportDateE
          this.selectTable = data.destinationPlaceId ? [{ id: data.destinationPlaceId, siteCnName: data.destinationPlace }] : []
          this.courseList = data.vehicleDeploymentOVoList
          this.courseDetailedList = data.vehicleDeploymentOApendVo
          console.info('this.courseList------------------------>', this.courseList)
          this.vehicleInfoList = []
          this.vehicleInfoList.push(data.vehicleInfoVo)
          // 开始时间
          let strDateList = []
          // 结束时间
          let enDateList = []
          if(this.courseList.length > 0){
            for(let i = 0; i < this.courseList.length; i++){
              // 获取集合中的开始时间
              strDateList.push(new Date(this.courseList[i].offeringDateS.replace(/-/g, '/')).getTime())
              // 获取集合中的结束时间
              enDateList.push(new Date(this.courseList[i].offeringDateE.replace(/-/g, '/')).getTime())
            }
            // 开始时间从小到大排序
            let strDateListS = []
            for (var i = 0; i < strDateList.length; i++) {
              for (var j = 0; j < strDateList.length -i - 1; j ++) {
                if (strDateList[j] > strDateList[j+1]) {  // 相邻元素两对比
                  strDateListS = strDateList [j+1];
                  strDateList[j+1]= strDateList [j];
                  strDateList[j] = strDateListS;
                }
              }
            }
            // 结束时间从小到大排序
            let enDateListS = []
            for (var i = 0; i < enDateList.length; i++) {
              for (var j = 0; j < enDateList.length -i - 1; j ++) {
                if (enDateList[j] > enDateList[j+1]) {  // 相邻元素两对比
                  enDateListS = enDateList [j+1];
                  enDateList[j+1]= enDateList [j];
                  enDateList[j] = enDateListS;
                }
              }
            }
            console.info('最早的开始时间------------------->', strDateList[0])
            console.info('最晚的结束时间------------------->', enDateList[enDateList.length - 1])
            console.info('最晚的结束时间------------------->', new Date(enDateList[enDateList.length - 1]))
            this.strDate =  new Date(strDateList[0])
            let enDate = new Date(enDateList[enDateList.length - 1])
            this.startTime = this.dataForm.transportDateS
            console.info('enDate-------------------->', enDate)
            this.endTime = enDate
          }
          console.info('this.dataForm.lastDate--------------------->', this.dataForm.lastDate)
          console.info('this.dataForm传入条件--------------------->', this.dataForm)
          this.nextPlan()
        })
      },
      // 该车辆下一个安排
      nextPlan(){
        let url = ''
        let param = ''
        console.info('this.dataForm.lastDate下一个安排的查询时间-------------->', this.dataForm.lastDate)
        url = '/rm/vehicleinfoDeployment/nextPlan'
        param = {
          ...this.dataForm,
        }
        this.$request.post(
                url, param
        ).then((data) => {
          console.info('data查看出来的值------------------->', data)
          if(data === null){
            this.dataFormNext = {
                  vehicleId:'',
                  bookType:'',
                  scheduleDateS:'',
                  scheduleDateE:'',
                  courseCode:'',
                  siteName:'',
                  offeringNo:'',
                  deploymentNo:'',
                  destinationPlace:'',
                  originalPlace:''
                }
            this.showNext = true
            this.showNextVehicle = false
            this.showNextVehicleNo = true
          }else{
            this.dataFormNext.vehicleId = data.vehicleId
            this.dataFormNext.bookType = data.bookType
            this.dataFormNext.bookTypeName = this.bookTypeFormatter(data.bookType)
            this.dataFormNext.scheduleDateS = data.scheduleDateS
            this.dataFormNext.scheduleDateE = data.scheduleDateE
            if(data.offeringInfoDTO !== null){
              // this.dataFormNext.courseCode = data.offeringInfoDTO.courseCode
              this.dataFormNext.siteName = data.offeringInfoDTO.siteName
              this.dataFormNext.offeringNo = data.offeringInfoDTO.offeringNo
            }
            if(data.vehicleDeploymentVo !== null){
              this.dataFormNext.deploymentNo = data.vehicleDeploymentVo.deploymentNo
              this.dataFormNext.destinationPlace = data.vehicleDeploymentVo.destinationPlace
              this.dataFormNext.originalPlace = data.vehicleDeploymentVo.originalPlace
            }
            this.showNext = true
            this.showNextVehicle = true
            this.showNextVehicleNo = false
          }
          console.info('this.dataFormNext----------------->', this.dataFormNext)
        })
      },
      // 编辑换车保存
      vehicleChange(){
        let _this = this
        _this.dataForm.id = ''
        console.info('this.dataForm变更后的------------->', this.dataForm)
        console.info('this.dataForm变更前的------------->', this.updateDataForm)
        let url = ''
        let param = ''
        url = '/rm/vehicleinfoDeployment/change'
        param = {
          'vehicleDeploymentVoBefore' : _this.updateDataForm,
          'vehicleDeploymentVoAfter': _this.dataForm
        }
        _this.$request.post(
                url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              _this.dataListLoading = false
              _this.tabRemove()
            }
          })
        }).catch((error) => {
          _this.dataListLoading = false
          console.error(error)
        })
      },
      // 归还申请
      returnAdd(row){
        console.info('row传到页面的值-------------------->', row)
        let name = 'rm-vehicleAllocation-return-add'
        let query = {}
        query.id = row.id
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.COURSE_VEHICALERELA, '')
      },
      // 表单提交
      dataFormSubmitHandle () {
        console.info('this.dataForm.vehicleId--------------------------->', this.dataForm.vehicleId)
        console.info('this.vehicleId--------------------------->', this.vehicleId)
        let _this = this
        // 未选目的地
        if(this.dataForm.destinationPlace === null || this.dataForm.destinationPlace === ''){
          this.$message.warning(this.$t('vehicleAllocation.selectDestinationPlace'))
          return false
        }
        // 调配原因为课程需要,但是未选课程
        if(_this.dataForm.deploymentReason === '10'){
          if(this.courseList.length === 0){
            this.$message.warning(this.$t('vehicleAllocation.selectCourse'))
            return false
          }
        }
        if(this.dataForm.transportDateS === '' || this.dataForm.transportDateE === ''){
          this.$message.warning(this.$t('vehicleAllocation.vehicleSelect'))
          return false
        }
        if(new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateS.replace(/-/g, '/')))).getTime() > new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE.replace(/-/g, '/')))).getTime()){
          this.$message.warning(this.$t('vehicleAllocation.comparisonTime'))
          return false
        }
          // if(new Date(this.dataForm.transportDateS) < new Date(new Date(new Date().toLocaleDateString()).getTime())){
          //     this.$message.warning(this.$t('vehicleAllocation.selectTransportDateS'))
          //     return false
          // }
          if(new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateS.replace(/-/g, '/')))).getTime() > new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE.replace(/-/g, '/')))).getTime()){
              this.$message.warning(this.$t('vehicleAllocation.compareDate'))
              return false
          }

        _this.dataListLoading = true
        // 判断车辆是否更换，如果更换，则先删除后新增，如果没有更换车，则调用修改接口
        if(_this.vehicleId !==  _this.dataForm.vehicleId){
          if(this.dataFormNext.bookType === '1'){
            if(this.dataFormNext.siteCode !== this.dataForm.destinationPlaceId){
              this.$confirm(this.$t('vehicleAllocation.schedulingConflicts'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
              }).then(() => {
                console.info('确定')
                this.dataForm.id = ''
                let url = ''
                let param = ''
                url = '/rm/vehicleinfoDeployment/change'
                param = {
                  'vehicleDeploymentVoBefore' : this.updateDataForm,
                  'vehicleDeploymentVoAfter': this.dataForm
                }
                this.$request.post(
                        url, param
                ).then((data) => {
                  _this.dataListLoading = false
                  this.tabRemove()
                  console.info('data保存之后------------------->', data)
                  this.returnAdd(data)
                }).catch((error) => {
                  _this.dataListLoading = false
                })
              }).catch(() => {
                console.info('取消')
                this.vehicleChange()
              })
            }else{
              this.vehicleChange()
            }
          }else if(this.dataFormNext.bookType === '2'){
            this.$confirm(this.$t('vehicleAllocation.deploymentConflict'), {
              confirmButtonText: this.$t('confirm'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            }).then(() => {
              console.info('确定')
              this.dataForm.id = ''
              let url = ''
              let param = ''
              url = '/rm/vehicleinfoDeployment/change'
              param = {
                'vehicleDeploymentVoBefore' : this.updateDataForm,
                'vehicleDeploymentVoAfter': this.dataForm
              }
              this.$request.post(
                      url, param
              ).then((data) => {
                _this.dataListLoading = false
                this.tabRemove()
                console.info('data保存之后------------------->', data)
                this.returnAdd(data)
              }).catch((error) => {
                _this.dataListLoading = false
              })
            }).catch(() => {
              console.info('取消')
              this.vehicleChange()
            })
          }else{
            this.vehicleChange()
          }

          return false
        }
        let url = ''
        let param = ''
        url = '/rm/vehicleinfoDeployment/update'
        param = {
          ..._this.dataForm,
          'vehicleDeploymentOVoList': _this.courseList
          // 'vehicleDeploymentOApendVo' : _this.vehicleInfoList
        }
        _this.$request.post(
                url, param
        ).then((data) => {
          _this.dataListLoading = false
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove()
            }
          })
        }).catch(() => {
          _this.dataListLoading = false
        })
      },
      // 删除当前页面
      /* tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      }, */
      // 页面关闭按钮
      backPage () {
        // this.$router.go(-1)
        let _this = this
        _this.$confirm(_this.$t('trainer.cancelinfo'), _this.$t('prompt.title'), {
          confirmButtonText: _this.$t('confirm'),
          cancelButtonText: _this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          _this.tabRemove()
        })
      },
      // 删除当前页面
      tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      },
      // 课程选择弹出页面事件
      selectCourseClick () {
        let dataList = this.courseList
        for(let i = 0; i < dataList.length; i++){
          this.courseList[i]['startdate'] = dataList[i].offeringDateS
          this.courseList[i]['enddate'] = dataList[i].offeringDateE
        }
        console.info('this.courseList--------------->', this.courseList)
        // 选择课程
          this.courseSelect = true
          this.$nextTick(() => {
            this.$refs.selCertCourseDialog && this.$refs.selCertCourseDialog.init()
          })
      },
      // 课程选择完成
      couronOk: function (data,strDate,enDate) {
        if(this.vehicleInfoList.length === 0){
          let _this = this
          _this.startTime = ''
          _this.endTime = ''
          _this.courseList = []
          let strDateE = this.dateFormat("YYYY-mm-dd",new Date(new Date(strDate) - 6 * 24 * 3600 * 1000))
          let date = this.dateFormat("YYYY-mm-dd",new Date())
          console.info('strDateE--------------->', strDateE)
          console.info('date--------------->', date)
          // if(strDateE > date){
            //   this.$message.warning(this.$t('vehicleAllocation.selectDestinationPlace'))
          //   return false
          // }
            let compareDate = new Date()
            if(new Date(new Date(strDate) - 6 * 24 * 3600 * 1000) < compareDate){
                console.info('满足条件-----------》',new Date(compareDate.setDate(compareDate.getDate()+1)))
                _this.dataForm.transportDateS = new Date(new Date(compareDate) + 1 * 24 * 3600 * 1000)
            }else{
                _this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
            }
          // _this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
          _this.dataForm.transportDateE = new Date(new Date(strDate) - 1 * 24 * 3600 * 1000)
          _this.strDate = strDate
          _this.enDate = enDate
          console.info('data1-------------------->',this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateS) + '00:00:00')
          console.info('data2-------------------->',this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateE))
          _this.startTime = _this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateS) + ' 00:00:00'
          _this.endTime = enDate
          _this.courseList = data
          for(let i = 0; i < data.length; i++){
            _this.courseList[i]['offeringDateS'] = data[i].startdate
            _this.courseList[i]['offeringDateE'] = data[i].enddate
          }
          this.courseSelect = false
        }else{
          this.$confirm(this.$t('vehicleAllocation.reSelectionVehicle'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            let _this = this
            _this.startTime = ''
            _this.endTime = ''
            _this.vehicleInfoList = []
            _this.dataForm.vehicleId = ''
            _this.dataForm.vehicleNo = ''
            _this.dataForm.originalPlaceId = ''
            _this.dataForm.originalPlace = ''
            _this.showNext = false
            _this.showNextVehicle = false
            _this.courseList = []
            let strDateE = this.dateFormat("YYYY-mm-dd",new Date(new Date(strDate) - 6 * 24 * 3600 * 1000))
            let date = this.dateFormat("YYYY-mm-dd",new Date())
            console.info('strDateE--------------->', strDateE)
            console.info('date--------------->', date)
            // if(strDateE > date){
            //   this.$message.warning(this.$t('vehicleAllocation.selectDestinationPlace'))
            //   return false
            // }
              let compareDate = new Date()
              if(new Date(new Date(strDate) - 6 * 24 * 3600 * 1000) < compareDate){
                  console.info('满足条件-----------》',new Date(compareDate.setDate(compareDate.getDate()+1)))
                  _this.dataForm.transportDateS = new Date(new Date(compareDate) + 1 * 24 * 3600 * 1000)
              }else{
                  _this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
              }
            // _this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
            _this.dataForm.transportDateE = new Date(new Date(strDate) - 1 * 24 * 3600 * 1000)
            _this.strDate = strDate
            _this.enDate = enDate
            console.info('data1-------------------->',this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateS) + '00:00:00')
            console.info('data2-------------------->',this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateE))
            _this.startTime = _this.dateFormat("YYYY-mm-dd",_this.dataForm.transportDateS) + ' 00:00:00'
            _this.endTime = enDate
            _this.courseList = data
            for(let i = 0; i < data.length; i++){
              _this.courseList[i]['offeringDateS'] = data[i].startdate
              _this.courseList[i]['offeringDateE'] = data[i].enddate
            }
            this.courseSelect = false
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      // 关闭课程选择页面
      cancel(){
        this.courseSelect = false
      },
      // 车辆选择弹出页面事件
      selectVehicleClick(){
        if(this.dataForm.transportDateS === '' || this.dataForm.transportDateE === ''){
          this.$message.warning(this.$t('vehicleAllocation.vehicleSelect'))
          return false
        }
        if(new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateS))).getTime() > new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE))).getTime()){
          this.$message.warning(this.$t('vehicleAllocation.comparisonTime'))
          return false
        }
        if(this.dataForm.destinationPlaceType === '20'){
          this.dataForm.destinationPlaceId = '-1'
        }

        this.startTime = this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateS.replace(/-/g, '/'))) + ' 00:00:00'
        if(this.dataForm.deploymentReason === '20'){
          // this.startTime = this.dataForm.transportDateS
          this.endTime = this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE.replace(/-/g, '/'))) + ' 23:59:59'
        }
        if(this.courseList.length > 0){
          console.info('this.courseList------------->' ,this.courseList)
          // 结束时间
          let enDateList = []
          for(let i = 0; i < this.courseList.length; i++){
            // enDateList.push(new Date(this.courseList[i].offeringDateE).getTime())
            enDateList.push(new Date(this.courseList[i].offeringDateE.replace(/-/g, '/')))
            console.info(i,'-------------------->',this.courseList[i].offeringDateE.replace(/-/g, '/'))
          }
          // 结束时间从小到大排序
          let enDateListS = []
          for (var i = 0; i < enDateList.length; i++) {
            for (var j = 0; j < enDateList.length -i - 1; j ++) {
              if (enDateList[j] > enDateList[j+1]) {  // 相邻元素两对比
                enDateListS = enDateList [j+1];
                enDateList[j+1]= enDateList [j];
                enDateList[j] = enDateListS;
              }
            }
          }
          console.info('enDateList-------------->', enDateList)
          console.info('最晚的结束时间------------------->', new Date(enDateList[enDateList.length - 1]))
          this.endTime = this.dateFormat("YYYY-mm-dd",new Date(enDateList[enDateList.length - 1])) + ' 23:59:59'
        }else{
          this.endTime = this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE.replace(/-/g, '/'))) + ' 23:59:59'
        }
        console.info('this.startTime开始时间-----------------', this.startTime)
        console.info('this.endTime结束时间-----------------', this.endTime)
        // 调用车辆弹框的初始化方法
        this.$nextTick(() => {
          this.isShowsite = true
          this.$refs.vehicleInfoRef && this.$refs.vehicleInfoRef.initMethod()
        })
      },
      // 车辆选择关闭页面事件
      handleClose () {
        this.isShowsite = false
      },
      // 弹出页面赋值给主页面
      onOk (selectList) {
        this.vehicleInfoList = selectList
        console.info('selectList----------------->', selectList[0])
        this.vehicleInfoList[0].classCnName = selectList[0].vehicleClass
        this.vehicleInfoList[0].companyCnName = selectList[0].belongCompanyNameZH
        this.vehicleInfoList[0].siteCnName = selectList[0].subordinateSite
        this.vehicleInfoList[0].presentSiteName = selectList[0].subordinateSite
        this.vehicleInfoList[0].vehicleClassification = selectList[0].vehicleClassId
        // this.dataForm.originalPlaceId = selectList[0].presentSiteId
        // this.dataForm.originalPlace = selectList[0].presentSiteName
        this.dataForm.vehicleNo = selectList[0].chassisNo
        this.dataForm.vehicleId = selectList[0].id
        this.isShowsite = false
        this.dataForm.lastDate = this.endTime
        if(this.dataForm.destinationPlaceId === selectList[0].subordinateSiteId && this.dataForm.deploymentReason !== '30'){
          this.$message.warning(this.$t('vehicleAllocation.sameVenue'))
          this.courseList = []
          this.allocationReasonsArr = this.enums['allocationReasons']
          this.dataForm.deploymentReason = '30'
        }
        // 获取始发地
        this.$request.post(
                '/rm/vehicleinfoDeployment/queryVehicleSiteInfo', { 'vehicleId' : this.dataForm.vehicleId ,'transportDateS': this.dataForm.transportDateS }
        ).then((data) => {
          console.info('data查看出来的值------------------->', data)
          this.dataForm.originalPlaceId = data.originalPlaceId
          this.dataForm.originalPlace = data.originalPlace
        })
        this.nextPlan()
      },
      // 车辆分类转换
      vehicleClassFormatter (row) {
        return Vue.filter('coverEnum')(row.vehicleClassification, 'vehicleClass')
      },
      showSuboSiteDlg () {
        this.isShowSuboSite = true
        this.$refs.suborSiteRef.initSuborSite()
      },
      closeSuboSiteDlg () {
        this.isShowSuboSite = false
      },
      // 状态转换
      statusFormatter (row) {
        return Vue.filter('coverEnum')(row, 'deploymentStatus')
      },
      // 安排类型:1.排期安排，2.运输安排
      bookTypeFormatter (row){
        if(row === '1'){
          return '排期安排'
        }else if(row === '2'){
          return '运输安排'
        }
      },
      deleteOffering(childrenIndex){
        if(this.courseList.length === 1){
          this.$confirm(this.$t('vehicleAllocation.deleteCouron'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.courseList.splice(childrenIndex, 1)
            this.dataForm.deploymentReason = '20'
            if(this.courseList.length > 0){
              // 开始时间
              let strDateList = []
              // 结束时间
              let enDateList = []
              if(this.courseList.length > 0){
                for(let i = 0; i < this.courseList.length; i++){
                  strDateList.push(new Date(this.courseList[i].offeringDateS.replace(/-/g, '/')).getTime())
                  enDateList.push(new Date(this.courseList[i].offeringDateE.replace(/-/g, '/')).getTime())
                }
              }
              // 开始时间从小到大排序
              let strDateListS = []
              for (var i = 0; i < strDateList.length; i++) {
                for (var j = 0; j < strDateList.length -i - 1; j ++) {
                  if (strDateList[j] > strDateList[j+1]) {  // 相邻元素两对比
                    strDateListS = strDateList [j+1];
                    strDateList[j+1]= strDateList [j];
                    strDateList[j] = strDateListS;
                  }
                }
              }
              // 结束时间从小到大排序
              let enDateListS = []
              for (var i = 0; i < enDateList.length; i++) {
                for (var j = 0; j < enDateList.length -i - 1; j ++) {
                  if (enDateList[j] > enDateList[j+1]) {  // 相邻元素两对比
                    enDateListS = enDateList [j+1];
                    enDateList[j+1]= enDateList [j];
                    enDateList[j] = enDateListS;
                  }
                }
              }
              // 取最早的排期开始时间
              console.info('最早的开始时间------------------->', new Date(strDateList[0]))
              console.info('最晚的结束时间------------------->', new Date(enDateList[enDateList.length - 1]))
              let strDate = new Date(strDateList[0])
              let enDate = new Date(enDateList[enDateList.length - 1])
              let compareDate = new Date()
              if(new Date(new Date(strDate) - 6 * 24 * 3600 * 1000) < compareDate){
                this.dataForm.transportDateS = new Date(compareDate.setDate(compareDate.getDate()+1))
              }else{
                this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
              }
              this.dataForm.transportDateE = new Date(new Date(strDate) - 1 * 24 * 3600 * 1000)
              this.strDate = strDate
              this.enDate = enDate
              console.info('data1-------------------->',this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateS) + '00:00:00')
              console.info('data2-------------------->',this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateE))
              this.startTime = this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateS) + ' 00:00:00'
              this.endTime = enDate
            }
            // else{
            //   this.dataForm.transportDateS = ''
            //   this.dataForm.transportDateE = ''
            // }
          }).catch((err) => {
            console.log(err)
          })
        }else{
           this.$confirm(this.$t('vehicleAllocation.deleteScheduled'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.courseList.splice(childrenIndex, 1)
        if(this.courseList.length > 0){
          // 开始时间
          let strDateList = []
          // 结束时间
          let enDateList = []
          if(this.courseList.length > 0){
            for(let i = 0; i < this.courseList.length; i++){
              strDateList.push(new Date(this.courseList[i].offeringDateS.replace(/-/g, '/')).getTime())
              enDateList.push(new Date(this.courseList[i].offeringDateE.replace(/-/g, '/')).getTime())
            }
          }
          // 开始时间从小到大排序
          let strDateListS = []
          for (var i = 0; i < strDateList.length; i++) {
            for (var j = 0; j < strDateList.length -i - 1; j ++) {
              if (strDateList[j] > strDateList[j+1]) {  // 相邻元素两对比
                strDateListS = strDateList [j+1];
                strDateList[j+1]= strDateList [j];
                strDateList[j] = strDateListS;
              }
            }
          }
          // 结束时间从小到大排序
          let enDateListS = []
          for (var i = 0; i < enDateList.length; i++) {
            for (var j = 0; j < enDateList.length -i - 1; j ++) {
              if (enDateList[j] > enDateList[j+1]) {  // 相邻元素两对比
                enDateListS = enDateList [j+1];
                enDateList[j+1]= enDateList [j];
                enDateList[j] = enDateListS;
              }
            }
          }
          // 取最早的排期开始时间
          console.info('最早的开始时间------------------->', new Date(strDateList[0]))
          console.info('最晚的结束时间------------------->', new Date(enDateList[enDateList.length - 1]))
          let strDate = new Date(strDateList[0])
          let enDate = new Date(enDateList[enDateList.length - 1])
          let compareDate = new Date()
          if(new Date(new Date(strDate) - 6 * 24 * 3600 * 1000) < compareDate){
            this.dataForm.transportDateS = new Date(compareDate.setDate(compareDate.getDate()+1))
          }else{
            this.dataForm.transportDateS = new Date(new Date(strDate) - 6 * 24 * 3600 * 1000)
          }
          this.dataForm.transportDateE = new Date(new Date(strDate) - 1 * 24 * 3600 * 1000)
          this.strDate = strDate
          this.enDate = enDate
          console.info('data1-------------------->',this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateS) + '00:00:00')
          console.info('data2-------------------->',this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateE))
          this.startTime = this.dateFormat("YYYY-mm-dd",this.dataForm.transportDateS) + ' 00:00:00'
          this.endTime = enDate
        }else{
          this.dataForm.transportDateS = ''
          this.dataForm.transportDateE = ''
        }
            }).catch((err) => {
              console.log(err)
          })
        }
        return false;
      },
      dataUpdate(type){
        console.info('new Date(this.dataForm.transportDateS).getTime()-------------->', new Date(this.dataForm.transportDateS).getTime())
        console.info('this.dataForm.transportDateE-------------->', new Date(this.dataForm.transportDateE.replace('-','/')).getTime())
        console.info('this.strDate------------------->', this.strDate)
        let cur = new Date();cur.setHours(0);cur.setMinutes(0);cur.setSeconds(0);cur.setMilliseconds(0);
        console.info('cur-------------->', cur)
        let curTime = new Date(cur).getTime()
        console.info('new Date().toLocaleDateString11111------>', curTime)
        console.info('获取当天的零点-------------->', curTime)
        if(type == 'start'){
          if(new Date(this.dataForm.transportDateS).getTime() < curTime){
            this.$message.warning(this.$t('vehicleAllocation.selectTransportDateS'))
            this.dataForm.transportDateS = this.updateDataForm.transportDateS
            return false
          }
        }else if(type == 'end'){
          if(new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateS.replace('-','/')))).getTime() > new Date(this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE))).getTime()){
            this.dataForm.transportDateE = this.updateDataForm.transportDateE
            this.$message.warning(this.$t('vehicleAllocation.compareDate'))
            return false
          }
        }
        if(this.dataForm.deploymentReason === '10' && this.courseList.length > 0){
          //选择排期之后计算出的运输结束时间，修改运输时间必须小于或等于此时间
          let primaryDate = this.dateFormat("YYYY-mm-dd",new Date(new Date(this.strDate) - 1 * 24 * 3600 * 1000))
          console.info('this.strDate--------------->', this.dateFormat("YYYY-mm-dd",new Date(new Date(this.strDate) - 1 * 24 * 3600 * 1000)))
          console.info('primaryDate--------------->', primaryDate)
          if(primaryDate < this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE.replace('-','/')))){
            this.$message.warning(this.$t('vehicleAllocation.selectTransportDateE'))
            this.dataForm.transportDateE = primaryDate
            return false
          }
        }
        this.startTime = this.dataForm.transportDateS + ' 00:00:00'
        // 需要判断初始化的vehicleDeploymentOApendVo  vehicleDeploymentOVoList两个对象
        if(this.vehicleDeploymentOVo.length === 0 && this.vehicleDeploymentOApendVo.length === 0){
          console.info('new Date(this.dataForm.transportDateE.replace(/-/g, \'/\')).getTime()----------->', new Date(this.dataForm.transportDateE.replace(/-/g, '/')).getTime())
          this.dataForm.lastDate = this.dateFormat("YYYY-mm-dd",new Date(new Date(this.dataForm.transportDateE.replace(/-/g, '/')).getTime() + 24 * 60 * 60 * 1000))
        }else{
          let dateList = []
          let vehicleDeploymentOVoList = []
          let vehicleDeploymentOApendVo = []
          if(this.vehicleDeploymentOVo.length > 0){
            // 结束时间
            // let enDateList = []
            if(this.vehicleDeploymentOVo.length > 0){
              for(let i = 0; i < this.vehicleDeploymentOVo.length; i++){
                vehicleDeploymentOVoList.push(new Date(this.vehicleDeploymentOVo[i].offeringDateE.replace('-','/')).getTime())
              }
            }
            // 结束时间从小到大排序
            // let enDateListS = []
            let vehicleDeploymentOVoListS = []
            for (var i = 0; i < vehicleDeploymentOVoList.length; i++) {
              for (var j = 0; j < vehicleDeploymentOVoList.length -i - 1; j ++) {
                if (vehicleDeploymentOVoList[j] > vehicleDeploymentOVoList[j+1]) {  // 相邻元素两对比
                  vehicleDeploymentOVoListS = vehicleDeploymentOVoList [j+1];
                  vehicleDeploymentOVoList[j+1]= vehicleDeploymentOVoList [j];
                  vehicleDeploymentOVoList[j] = vehicleDeploymentOVoListS;
                }
              }
            }
            // console.info('最早的开始时间------------------->', new Date(strDateList[0]))
            console.info('vehicleDeploymentOVoList最晚的结束时间------------------->', new Date(vehicleDeploymentOVoList[vehicleDeploymentOVoList.length - 1]))
            // vehicleDeploymentOVoList集合中最晚的结束时间
            let schedulingDate = new Date(vehicleDeploymentOVoList[vehicleDeploymentOVoList.length - 1])
            console.info('dateList1-------------------->', this.dateFormat("YYYY-mm-dd",schedulingDate))
            dateList.push(schedulingDate)
          }
          if(this.vehicleDeploymentOApendVo.length > 0){
            // 结束时间
            // let enDateList = []
            if(this.vehicleDeploymentOApendVo.length > 0){
              for(let i = 0; i < this.vehicleDeploymentOApendVo.length; i++){
                vehicleDeploymentOApendVo.push(new Date(this.vehicleDeploymentOApendVo[i].offeringDateE.replace('-','/')).getTime())
              }
            }
            // 结束时间从小到大排序
            // let enDateListS = []
            // let vehicleDeploymentOVoListS = []
            let vehicleDeploymentOApendVoListS = []
            for (var i = 0; i < vehicleDeploymentOApendVo.length; i++) {
              for (var j = 0; j < vehicleDeploymentOApendVo.length -i - 1; j ++) {
                if (vehicleDeploymentOApendVo[j] > vehicleDeploymentOApendVo[j+1]) {  // 相邻元素两对比
                  vehicleDeploymentOApendVoListS = vehicleDeploymentOApendVo [j+1];
                  vehicleDeploymentOApendVo[j+1]= vehicleDeploymentOApendVo [j];
                  vehicleDeploymentOApendVo[j] = vehicleDeploymentOApendVoListS;
                }
              }
            }
            // console.info('最早的开始时间------------------->', new Date(strDateList[0]))
            console.info('vehicleDeploymentOVoList最晚的结束时间------------------->', new Date(vehicleDeploymentOApendVo[vehicleDeploymentOApendVo.length - 1]))
            // vehicleDeploymentOApendVo集合中最晚的结束时间
            let schedulingDetailedDate = new Date(vehicleDeploymentOApendVo[vehicleDeploymentOApendVo.length - 1])
            console.info('dateList2-------------------->', this.dateFormat("YYYY-mm-dd",schedulingDetailedDate))
            dateList.push(schedulingDetailedDate)
          }
          // 判断三个时间的大小
          console.info('dateList3-------------------->', this.dateFormat("YYYY-mm-dd",new Date(this.dataForm.transportDateE)))
          dateList.push(new Date(this.dataForm.transportDateE.replace(/-/g, '/')))
          console.info('dataList4--------------->', new Date(this.dataForm.transportDateE.replace(/-/g, '/')))
          // 从小到大排序
          // let enDateListS = []
          let dateListS = []
          for (var i = 0; i < dateList.length; i++) {
            for (var j = 0; j < dateList.length -i - 1; j ++) {
              if (dateList[j] > dateList[j+1]) {  // 相邻元素两对比
                dateListS = dateList [j+1];
                dateList[j+1]= dateList [j];
                dateList[j] = dateListS;
              }
            }
          }
          console.info('最晚的结束时间----------------------->', this.dateFormat("YYYY-mm-dd",new Date(dateList[dateList.length - 1])))
          console.info('dateList计算出来的时间集----------------->',dateList)
          console.info('new Date(dateList[dateList.length - 1]).getTime()---------->', new Date(dateList[dateList.length - 1]).getTime())
          this.dataForm.lastDate = this.dateFormat("YYYY-mm-dd",new Date(new Date(dateList[dateList.length - 1]).getTime() + 24 * 60 * 60 * 1000))
        }
        if(this.dataForm.vehicleId !== ''){
          // 该车辆下一个安排
          let url = ''
          let param = ''
          console.info('this.dataForm,--------------->查询', this.dataForm)
          url = '/rm/vehicleinfoDeployment/nextPlan'
          param = {
            ...this.dataForm,
          }
          this.$request.post(
                  url, param
          ).then((data) => {
            console.info('data查看出来的值------------------->', data)
            if(data === null){
              this.showNextVehicleNo = true
              this.showNextVehicle = false
            }else{
              this.dataFormNext.vehicleId = data.vehicleId
              this.dataFormNext.bookType = data.bookType
              this.dataFormNext.bookTypeName = this.bookTypeFormatter(data.bookType)
              this.dataFormNext.scheduleDateS = data.scheduleDateS
              this.dataFormNext.scheduleDateE = data.scheduleDateE
              if(data.offeringInfoDTO == null){
                this.dataFormNext.courseCode = ''
                this.dataFormNext.siteName = ''
              }else{
                this.dataFormNext.courseCode = data.offeringInfoDTO.courseCode
                this.dataFormNext.siteName = data.offeringInfoDTO.siteName
              }
              this.showNextVehicleNo = false
              this.showNextVehicle = true
            }
          })
          this.showNext = true
        }
      },
      // 查看标签
      checkLable(row){
        this.isShowLable = true
        this.$request.get(`/rm/vehicleinfo/info/${row.id}`).then((data) => {
          // 已选择的标签
          this.checkList = data.commLabelVoList ? data.commLabelVoList : []
          // 特殊情况，自己国际化
          const language = VueI18n.locale
          if (language === 'zh-CN') {
            // this.checkList.forEach(o => {
            //   o.labelName = o.labelNameCn
            // })
            for(let i = 0; i < this.checkList.length; i ++){
              if(this.checkList[i].labelNameCn !== null){
                this.checkList[i].labelName = this.checkList[i].labelNameCn
              }else{
                this.checkList.splice(i,1)
                i--
              }
            }
          } else {
            // this.checkList.forEach(o => {
            //   o.labelName = o.labelNameEn
            // })
            for(let i = 0; i < this.checkList.length; i ++){
              if(this.checkList[i].labelNameEn !== null){
                this.checkList[i].labelName = this.checkList[i].labelNameEn
              }else{
                this.checkList.splice(i,1)
                i--
              }
            }
          }
        })
      },
      showLableClose(){
        this.isShowLable = false
      },
      getBussinessType (val) {
        this.dataForm.bussinessTypeId = 16
        this.bussinessTypeId = 16
      },
      changeCheckedList (array) {
        this.checkList = array
      },
      // 重新勾选业务标签
      fatherMethod () {
        this.checkList = []
        // 已选择的标签
        this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
      },
      //  场地分类带回数据赋值
      bringBack (selection) {
        if(selection <= 0){
          this.$message.warning(this.$t('res.rela.selectCheck'))
          return false
        }
        if(this.courseList.length === 0|| this.vehicleInfoList.length === 0){
          let rowData = selection[0]
          let siteId = rowData.id
          let siteCnName = rowData.siteCnName
          this.dataForm['destinationPlaceId'] = siteId.toString()
          this.dataForm['destinationPlace'] = siteCnName
          this.selectTable = siteId ? [{ id: siteId, siteCnName: siteCnName }] : []
          this.courseList = []
          this.dataForm.transportDateS = ''
          this.dataForm.transportDateE = ''
          this.vehicleInfoList = []
          this.dataForm.originalPlace = ''
          this.showNext = false
          this.showNextVehicle = false
          this.isShowSuboSite = false
        }else{
          this.$confirm(this.$t('vehicleAllocation.reSelectionCouron'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            let rowData = selection[0]
            let siteId = rowData.id
            let siteCnName = rowData.siteCnName
            this.dataForm['destinationPlaceId'] = siteId.toString()
            this.dataForm['destinationPlace'] = siteCnName
            this.selectTable = siteId ? [{ id: siteId, siteCnName: siteCnName }] : []
            this.courseList = []
            this.dataForm.transportDateS = ''
            this.dataForm.transportDateE = ''
            this.vehicleInfoList = []
            this.dataForm.originalPlace = ''
            this.dataForm.originalPlaceId = ''
            this.dataForm.vehicleId = ''
            this.dataForm.vehicleNo = ''
            this.dataForm.lastDate = ''
            this.showNext = false
            this.showNextVehicle = false
            this.isShowSuboSite = false
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      selectdestinationPlaceType(){
        this.dataForm.destinationPlace = ''
        this.dataForm.destinationPlaceId = ''
        this.selectTable = []
      },
      // 时间格式化
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },
      Update (type) {
      let name = 'rm-vehicleAllocation-update'
      let query = {}
      query.id = this.$route.query.id
      query.type = type
      query.states = this.$route.query.states
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.COURSE_VEHICALERELA, '')
    },
      // allocationReasonsFilter(){
      //   console.info('this.allocationReasonsArr---------------->', JSON.parse(JSON.stringify(this.allocationReasonsArr)))
      //   this.allocationReasonsList = JSON.parse(JSON.stringify(this.allocationReasonsArr))
      //   if (this.allocationReasonsList.length === 3) {
      //     this.allocationReasonsList.splice(3, 2)
      //   }
      // }
    }
  }
</script>
<style scoped>
  @import "../../css/pkg-styles.css";
  .link-type,
  .link-type:focus {
    color: #337ab7;
    cursor: pointer;
  }
  .link-type:hover {
    color: rgb(32, 160, 255);
  }
</style>
<style>
  .briefContent > .el-input__count {
    position: initial !important;
    float: right !important;
  }
</style>
